import React from "react"

function LitigationClientHeader({ setSearchParameter, setHitReload }) {
  return (
    <div className="row d-flex d-wrap justify-between filter-section">
      <div className="col-md-6">
        <h4 className="page-title">Clients</h4>
      </div>
      <div className="col-md-6">
        {/* Search and filter controls will go here */}
      </div>
    </div>
  )
}

export default LitigationClientHeader